// 视图命名空间片段（zh/en 同文件，避免跨文件不同步）
import dashboard from './views/dashboard'
import launch from './views/launch'
import formtpl from './views/formtpl'
import assets from './views/assets'
import landing from './views/landing'
import guard from './views/guard'
import lplogs from './views/lplogs'
import adsExtra from './views/ads'
import admanager from './views/admanager'

// 中文文案字典。按命名空间组织：common(通用按钮) / nav(导航) / role(角色) /
// status(状态术语，配合 useStatus.js) / layout(外壳) / login / 各业务页。
// 新增 UI 文案：先在这里加 key（zh.js + en.js 同步），模板里用 t('ns.key')。
export default {
  tg: {
    title: 'Telegram 通知绑定',
    tabMine: '我的绑定', tabAdd: '添加绑定', tabTeam: '团队成员',
    loadFail: '加载 TG 绑定信息失败',
    noneYet: '尚未绑定 Telegram——止损/异常告警将无法第一时间送达。',
    bindNow: '立即绑定',
    verifiedAt: '最后验证 {ts}', unverified: '未验证（发一条测试消息即验证）', boundAt: '绑定于 {ts}',
    sendTest: '发送测试消息', sending: '发送中…', addAnother: '+ 添加绑定', multiNote: '告警将同时发送到以上全部 Telegram。',
    unbind: '解绑', unbindConfirm: '解绑 Telegram {id}？解绑后该 TG 不再收到告警。', unbound: '已解绑',
    testSent: '测试消息已发送到 {n} 个 TG，请查收',
    // 通知范围（TG 偏好矩阵：warning/info 可关，critical 恒推）
    prefsTitle: '通知范围', prefsCritical: '严重告警', prefsLocked: '始终推送，无法关闭',
    prefsWarning: '警告通知', prefsInfo: '提示',
    prefsNote: '关闭的级别仅不再推送到 Telegram，站内通知不受影响；严重告警始终推送。',
    prefsSaved: '✅ 通知偏好已保存',
    step1: '点击按钮打开 Telegram 发送绑定命令（或复制命令手动发送）',
    openTg: '打开 Telegram 绑定',
    copyCmd: '复制命令', cmdCopied: '命令已复制（30 分钟内有效）',
    cmdHint: '点按钮不会重发命令（与 Bot 的对话已存在时）——复制上方命令粘贴到 Bot 对话发送；「复制命令」每次得新码',
    step2: 'Bot 回复「绑定成功」即完成，本页会自动刷新',
    waiting: '等待绑定结果…（发送命令后几秒内自动检测）',
    manualFold: '其他方式：手动填写数字 chat_id',
    manualPh: 'Telegram 数字 ID（如 123456789）', manualBind: '手动绑定',
    manualHint: '先给 Bot 发送 /start，把回复里的数字 ID 填到上面。',
    botNotConfigured: '管理员尚未配置 TG Bot，无法绑定',
    teamEmpty: '暂无成员', colUser: '成员', colRole: '角色', colTg: 'TG 绑定',
    meTag: '（我）', noBinding: '未绑定', teamNote: '未绑定的成员收不到 TG 告警（仍可通过站内通知查看）。',
    boundToast: '✅ TG 绑定成功！', opFail: '操作失败',
  },
  common: {
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    ok: '知道了',
    close: '关闭',
    edit: '编辑',
    add: '新增',
    create: '创建',
    delete: '删除',
    remove: '移除',
    copy: '复制',
    copied: '已复制',
    search: '搜索',
    filterByToken: '只看令牌：{name}',
    clearFilter: '清除筛选',
    custom: '自定义',
    query: '查询',
    refresh: '刷新',
    exportCsv: '导出 CSV',
    loading: '加载中…',
    operation: '操作',
    action: '操作',
    status: '状态',
    remark: '备注',
    name: '名称',
    all: '全部',
    none: '无',
    total: '共 {n} 项',
    yes: '是',
    no: '否',
    enable: '启用',
    disable: '停用',
    saved: '已保存',
    saving: '保存中',
    discard: '放弃',
    clear: '清除', rename: '重命名',
    done: '完成',
    back: '返回',
    detail: '详情',
    more: '更多',
    optional: '可选',
    required: '必填',
    noData: '暂无数据',
    success: '成功', createdOk: '创建成功',
    fail: '失败',
    retry: '重试',
    export: '导出',
    import: '导入',
    preview: '预览',
    upload: '上传',
    download: '下载',
    selectPlaceholder: '请选择',
    inputPlaceholder: '请输入',
    savedOk: '保存成功',
    opFail: '操作失败',
    delConfirm: '确定删除？此操作不可撤销。',
    tip: '提示',
    unit: '单位',
    today: '今日',
    yesterday: '昨日',
    last2days: '近2天',
    last7days: '近7天',
    last30days: '近30天',
  },
  error: {
    copyBtn: '复制',
    copiedError: '已复制错误信息',
    copyFail: '复制失败，请手动选中',
    opFail: '操作失败',
    unknown: '未知错误',
    uncaptured: '未捕获的异常',
    pageError: '页面错误',
    unauthorized: '未登录或登录已过期，请重新登录',
    timeout: '请求超时',
  },
  role: {
    owner: '管理员',
    operator: '运营',
    finance: '财务',
    superadmin: '平台超管',
    super: '超管',
  },
  nav: {
    groupData: '数据中心',
    groupAds: '广告管理',
    groupAuto: '自动化',
    groupAuth: '授权',
    groupBilling: '账务',
    groupSystem: '系统',
    dashboard: '数据看板',
    ads: '广告账户',
    'ad-manager': '广告管理器',
    'launch-templates': '投放模板',
    'form-templates': '表单模板',
    assets: '素材库',
    domains: '域名',
    landing: '投放链接',
    guard: '规则引擎',
    tokens: '令牌',
    wallet: '钱包',
    settings: '设置',
    members: '成员权限',
    logs: '操作日志',
    'admin-teams': '团队管理',
    'kpi-mapping': '转化映射',
  },
  fbError: {
    cert_required: '需完成 Meta 非歧视政策认证',
    invalid_param: '请求参数错误',
    bid_required: '需明确竞价策略',
    regulated_opt: '该优化目标在此地区不可用',
    regulated_missing: '受监管广告需认证身份',
    audience: '受众定向不被接受',
    audience_size: '受众太窄或无效',
    abuse: '内容触发风控',
    dev_mode: 'Meta App 处于开发者模式',
    rate_limited: '请求过频，稍后重试',
    rate_concurrent: '操作过于频繁（30 秒内多次），本次未生效，请稍等重试',
    has_spend: '近期有消耗，无需保活',
    no_write_token: '无可写令牌',
    has_keepalive: '已有保活广告',
    keepalive_burnt: '保活连续失败已暂停自动重试——请在广告账户「指定保活主页」改为账户绑定的主页后，点「立即保活」重试',
    no_page: '无可用主页',
    no_page_token: '令牌无此主页权限',
    no_asset: '无保活素材',
    asset_missing: '素材文件丢失',
    error: '未知错误',
    generic: 'Facebook 返回错误',
  },
  status: {
    // FB 账户 disable_reason（官方语义，复审R3-P1 校准：1诚信政策/2支付失败/3+5灰号关停/4支付风险/7不活跃/8待定）
    drAdsIntegrity: '广告诚信政策', drPaymentFailure: '支付失败', drGrayAccount: '灰色账号关停',
    drRiskPayment: '支付风险', drInactiveAccount: '不活跃关停', drUndecided: '待定',
    drUnsupportedBusiness: 'Unsupported business', drMiscMkt: 'misc_mkt',
    drAnCrowdsource: 'AN_CROWDSOURCE', drCanadaCra: 'CANADA_CRA', drChinaBci: 'CHINA_BCI',
    drRpTosViolation: 'RP_TOS_VIOLATION', drMexicoProfeco: 'MEXICO_PROFECO',
    drAgePolicy: '年龄政策', drWeatherSensor: 'WEATHER_SENSOR',
    drGoodStanding: 'GOOD_STANDING_VIOLATED', drRomaniaAnpc: 'ROMANIA_ANPC',
    drMisrepresentation: '虚假陈述',
    // FB 广告 effective_status
    adActive: '投放中',
    adPaused: '已暂停',
    adCampaignPaused: '系列暂停',
    adsetPaused: '广告组暂停',
    adArchived: '已归档',
    adDeleted: '已删除',
    adDisapproved: '被拒',
    adReview: '审核中',
    adPreview: '预览',
    adInProcess: '处理中',
    adIdle: '无在投广告',
    adWithIssues: '有问题',
    // TikTok 广告状态（tt_client _STATUS_MAP/_OPT_STATUS + 审核 show_status）
    ttEnable: '投放中',
    ttDisable: '已暂停',
    ttDelete: '已删除',
    ttComplete: '已结束',
    ttBudgetExceed: '预算耗尽',
    ttInProcess: '处理中',
    ttShowYes: '审核通过',
    ttShowNotStart: '待投放',
    ttShowNo: '审核未通过',
    // 账户 account_status
    accActive: '可用',
    accDisabled: '已禁用',
    accUnsettled: '未结算',
    accBanned: '被封',
    accPendingClose: '待关闭',
    accClosed: '已关闭',
    // 部署任务
    jobPending: '等待',
    jobRunning: '运行中',
    jobCompleted: '已完成',
    jobPartial: '部分失败',
    jobFailed: '失败',
    // 部署单项
    itemPending: '等待',
    itemCreating: '创建中',
    itemSuccess: '✓ 成功',
    itemFail: '✗ 失败',
    // 子码
    subActive: '投放中',
    subReserved: '保留',
    subArchived: '已归档',
    subDeleted: '已删除',
    // 落地页
    lpPublished: '已发布',
    lpDraft: '草稿',
    lpArchived: '已归档',
    // 租户/成员
    tenantActive: '正常',
    tenantMustChangePwd: '待重设密码',
    tenantInvited: '已邀请',
    tenantSuspended: '已停用',
    tenantArchived: '已归档',
    // 素材 AI
    aiPending: '待分析',
    aiAnalyzing: '分析中',
    aiDone: '✓ 已分析',
    aiFailed: '✗ 失败',
    aiNone: '未分析',
    // token
    tokenValid: '可用',
    tokenInvalid: '失效',
    tokenThrottled: '限流',
    tokenPending: '待认证',
  },
  cmdk: {
    placeholder: '搜索账户 / 模板 / 落地页 / 主页…',
    noResults: '无匹配结果',
    hint: '↑↓ 选择 · Enter 跳转 · ESC 关闭',
  },
  layout: {
    platformFilter: '平台筛选（数据看板/广告管理器按所选平台过滤）', platformKey: '平台 ',
    platformScopeAll: '全部平台 · 数据跨平台汇总', platformScopeFb: 'Facebook · 数据按此平台过滤', platformScopeTt: 'TikTok · 数据按此平台过滤',
    sentinel: '哨兵', scdCountdown: '倒计时', sentinelTip: '紧急自动停投：开启后你名下账户投放中的广告系列将全部暂停', gpGoGuard: '进入规则引擎页', scdSoon: '即将触发', scdMin: '剩{n}分钟', scdHr: '剩{n}小时', scdConflict: '哨兵已开启（正在停广告），先关闭哨兵再开启倒计时',
    rulesCount: '规则 {n} 条',
    safetyGuard: '安全守护',
    emergencyPause: '紧急暂停', lastEmergency: '上次暂停', emergencyTip: '立即暂停名下全部 ACTIVE 广告系列（含超管只作用本人名下）', keepaliveTip: '扫描名下有消耗风险的广告并暂停（保活名单不豁免）', emgDone: '停{n}系列 · 扫{m}账户', emgBad: '核验未过/报错 {n} 条', emgViewLog: '点击查看完整执行报告（规则引擎页 · 暂停记录）',
    pausing: '暂停中…',
    emergencyTitle: '⚠️ 紧急暂停',
    emergencyConfirm: '确定要紧急暂停？将暂停你名下所有在管账户投放中的整个广告系列（与哨兵一致）。此操作不可撤销。',
    emergencyConfirmBtn: '确认暂停',
    emergencyResultTitle: '紧急暂停结果',
    emergencyResult: '已暂停 {paused} 个系列（广告系列整体暂停） / 覆盖账户 {total} 个\n核验未过 {failed} 条\n明细见规则引擎页「暂停记录」',
    emergencyErrors: '错误明细',
    emergencyStillRunning: '紧急暂停仍在执行中，稍后可在安全面板查看结果',
    emergencyFail: '失败：{msg}',
    keepalivePause: '关闭保活', keepaliveConfirmTitle: '⚠️ 关闭保活', keepaliveConfirm: '确定关闭保活？将暂停你名下账户中所有投放中的保活系列。此操作不可撤销。', keepaliveConfirmBtn: '确认关闭', keepaliveResultTitle: '关闭保活结果', keepaliveResult: '已暂停 {paused} 条保活系列 / 扫描账户 {scanned} 个', keepaliveStillRunning: '关闭保活仍在执行中，稍后可查看结果', keepaliveFail: '失败：{msg}',
    sentinelTitle: '⚠️ 关闭哨兵',
    sentinelDisarmConfirm: '哨兵是自动急停保护（消耗异常时自动暂停你名下账户的广告）。关闭后你名下账户的异常消耗将不再被自动拦截，确定关闭？',
    notifTitle: '最近通知',
    notifEmpty: '暂无通知', notifViewAll: '查看全部告警 → 告警中心', notifAdAlertHint: '广告类告警（止损/扩量/令牌/账户）在这里查看，不在铃铛推送',
    noTeam: '未加入团队',
    current: '当前',
    switchedTeam: '已切换到「{name}」',
    switchFail: '切换失败',
    logout: '退出登录',
    themeToLight: '切亮色',
    themeToDark: '切暗色',
    langToEn: '切换到英文',
    langToZh: '切换到中文',
    notMember: '未加入团队',
  },
  login: {
    title: 'Tova Ads',
    subtitle: '广告智能管理平台',
    email: '邮箱',
    emailPlaceholder: '请输入邮箱',
    password: '密码',
    passwordPlaceholder: '请输入密码',
    signIn: '登录',
    signingIn: '登录中…',
    errEmail: '请输入邮箱',
    errPassword: '请输入密码',
    errFill: '请输入邮箱和密码',
    errCreds: '邮箱或密码错误',
    errDisabled: '账号已停用，请联系管理员',
    mustChangePwd: '首次登录请先修改初始密码（设置 → 账号）', errGeneric: '登录失败，请重试',
    // 自助注册 + 邮箱验证
    toRegister: '注册账号', toLogin: '返回登录',
    teamName: '团队名', teamNamePlaceholder: '请输入团队名称',
    usernamePlaceholder: '用户名（可选，便于识别）',
    confirmPassword: '确认密码', confirmPasswordPlaceholder: '请再次输入密码',
    signUp: '注册', signingUp: '注册中…',
    errTeamName: '请输入团队名', errPwdShort: '密码至少 8 位', errPwdMismatch: '两次输入的密码不一致',
    registerOk: '注册成功，请查收验证邮件完成邮箱验证',
    registerOkNoEmail: '注册成功，但验证邮件发送失败，登录后可在登录页重发',
    verifyTitle: '邮箱验证', verifying: '验证中…',
    verifyOk: '邮箱已验证，现在可以登录了', verifyFail: '验证链接无效或已过期',
    goLogin: '去登录',
    notVerified: '请先验证邮箱（可在登录页重发验证邮件）',
    // 忘记密码 / 重置密码
    forgotPwd: '忘记密码？', forgotTitle: '找回密码', forgotSub: '输入注册邮箱，我们将发送重置链接',
    sendReset: '发送重置链接', sendingReset: '发送中…',
    forgotOk: '如果该邮箱已注册，重置链接已发送（30 分钟内有效）',
    resetTitle: '重置密码', resetSub: '设置新密码',
    newPassword: '新密码', newPasswordPlaceholder: '请输入新密码（至少 8 位）',
    confirmNewPassword: '确认新密码', confirmNewPasswordPlaceholder: '请再次输入新密码',
    submitReset: '确认重置', submittingReset: '重置中…',
    resetOk: '密码已重置，请用新密码登录', resetFail: '重置链接无效或已过期',
    backToLogin: '返回登录',
  },
  ads: {
    ...adsExtra.zh,
    title: '广告账户',
    accountCount: '{n} 个账户',
    account: '账户',
    balance: '未结算',
    unbilledTip: 'FB 未结账单欠款：已消耗但尚未出账单的部分，不是可花额度（出账单后归零）',
    availTip: '还能花多少 = 花费上限 − 历史总消耗（换算 USD）；未设上限的账户不计入低额判断',
    availableCredit: '可用额度',
    spend: '消耗',
    conversions: '转化',
    activeToken: '生效令牌',
    custom: '自定义',
    query: '查询',
    loadAccounts: '载入账户', syncCampaigns: '采集广告', syncBgStarted: '后台同步中，约 1-2 分钟后自动刷新查看',
    batchSyncNoToken: '选中账户均未绑定令牌',
    selected: '已选 {n}',
    batchSync: '批量同步',
    batchRemove: '批量移除纳管',
    warmupArm: '开启保活',
    warmupDisarm: '取消保活',
    warmupShort: '保活',
    kaActiveAd: '保活中', kaHasSpend: '有消耗·免保活', kaBurnt: '保活已暂停', kaFailed: '保活失败',
    kaBadgeClickTip: '保活连续失败已暂停——点击指定保活主页后重试',
    kaPageMenu: '保活主页', kaNowMenu: '立即保活', kaPageTitle: '指定保活主页',
    kaPageAuto: '自动挑选（默认）', kaPageAutoHint: '从可写令牌有广告权限的主页里依次尝试',
    kaPageAdvOk: '✓ 可投广告', kaPageAdvNo: '⚠ 无广告权限（选它会被 FB 拒）', kaPageFans: '粉丝',
    kaPageNone: '该账户的可写令牌访问不到任何主页', kaPageHint: '指定主页须与账户创建时绑定的主页一致，否则会被 FB 拒绝。请联系账户提供方确认绑定的主页。',
    kaPageFix: '指定主页', kaPageClearBtn: '清除指定',
    kaPageSaved: '保活主页已保存', kaPageCleared: '已清除指定（回到自动挑选）',
    kaPageSaveRetry: '保存并重试', kaRetrying: '重试中…', kaRetrySuperOnly: '单账户重试仅超管可用——已保存，下次每日扫描自动重试',
    kaRetryOk: '保活广告创建成功', kaRetrySkip: '本次跳过', kaRetryFail: '重试失败',
    warmupBadgeTip: '保活中：闲置时自动建小额广告防休眠（巡检/哨兵照常跑，不影响止损）',
    unnamedAccount: '未命名账户',
    openAdManager: '点开广告管理器',
    unbound: '未绑',
    tokenOk: '可用',
    tokenAbnormal: '异常',
    rotatingToken: '轮换令牌：{aliases}',
    poolTooltip: '候选池 {n} 个令牌',
    viewInManager: '在广告管理器中查看', viewLandingLogs: '查看落地页日志',
    syncStatusBalance: '同步状态/余额',
    removeManaged: '移除纳管',
    emptyTitle: '还没有纳管的广告账户',
    emptyStep1: '① 先去', emptyStep1Tt: '① 先去', emptyLinkTt: '令牌页连接 TikTok 授权',
    emptyLink: 'Facebook 授权',
    emptyStep1b: '绑定令牌',
    emptyStep2: '② 回到本页点「载入账户」导入',
    noLoadable: '无可载入账户（先在令牌页绑定 Facebook 令牌或连接 TikTok）',
    loadDegraded: '⚠ 以下令牌拉取失败（可能限流中），其名下账户暂未列出：{names}——稍后重开本弹窗即可',
    runKeepalive: '立即保活',
    importedTag: '已导入',
    importableTag: '可导入',
    importing: '导入中…',
    importSelected: '导入选中',
    selectAccountsFirst: '先勾选账户',
    selectToImport: '勾选要导入的账户',
    noBoundToken: '该账户未绑定令牌',
    batchRemoveConfirm: '移除 {n} 个账户纳管？平台侧广告将继续消耗，止损/哨兵/紧急暂停即刻不再覆盖（历史数据保留）',
    batchWarmupConfirm: '确认对 {n} 个账户{act}？将批量修改保活名单状态', kaArmOn: '开启保活名单', kaArmOff: '移出保活名单',
    removeConfirm: '移除「{name}」纳管？平台侧广告将继续消耗，止损/哨兵/紧急暂停即刻不再覆盖（历史数据保留）',
    removed: '已移除 {n} 个账户',
    removedSimple: '已移除',
    refreshed: '已刷新 {n} 个账户',
    refreshedSimple: '已刷新',
    imported: '已导入 {n} 个（跳过已存在 {skipped}）',
    idCopied: 'ID 已复制：{id}',
    copyFail: '复制失败，请手动选中',
    syncing: '同步 {done}/{total}…',
    batchSyncResult: '成功 {ok} / 失败 {fail}：\n\n{errs}',
    batchRemoveResult: '已移除 {ok} / 失败 {fail}：\n\n{errs}',
    batchSyncFailDetail: '批量同步失败明细',
    warmupToggled: '{label} {n} 个账户',
    balLimited: '有限',
    balUnlimited: '不限',
    balHighLimited: '高限',
    opFailMsg: '失败：{msg}',
    searchPh: '搜索账户名 / ID',
    noMatch: '无匹配账户',
  },
  tokens: {
    assetTokens: '令牌', assetPages: '主页', assetBm: 'BM 资产', pageTitle: '令牌',
    statusCount: '{ok} 可用 · {off} 不可用',
    loadFail: '加载失败',
    openDetailTip: '点击查看令牌详情（账户 / 主页 / BM / 权限）',
    closeLoadConfirm: '已勾选 {n} 个账户尚未导入，关闭将丢失勾选。确定关闭？',
    oauthSuccess: 'Facebook 授权成功，令牌已导入',
    oauthFail: '授权失败：{msg}',
    abnormal: '异常',
    abnormal0: '异常',
    typeOperate: '可写',
    typeOperateTitle: '可写令牌：可写广告 + 读 + 可暂停',
    typeManage: '管理',
    typeManageTitle: '管理令牌：读 + 可暂停，不建新广告',
    typeUser: '只读',
    typeUserTitle: '只读令牌：仅查看，不可写/暂停',
    sourceManual: '手动',
    justNow: '刚刚',
    minutesAgo: '{n}分前',
    hoursAgo: '{n}时前',
    copiedId: '已复制 {id}',
    copyFail: '复制失败，请手动选择',
    refreshAll: '刷新全部',
    checkingProgress: '检测 {done}/{total}…',
    refreshAllResult: '完成：{ok} 个正常，{fail} 个异常',
    refreshAllResultWarn: '（异常已标红，点详情查看）',
    refreshing: '刷新中…',
    accountsRefreshed: '已刷新 {n} 个账户',
    refreshFail: '刷新失败：',
    unmanageWarning: '⚠ 移除后平台侧广告将继续消耗；止损/哨兵/紧急暂停即刻不再覆盖该账户。', unmanageAdsLeft: '（移除时该账户仍有 {n} 条 ACTIVE 广告在投）', unmanageConfirm: '移除纳管「{name}」？将不再管理此账户（令牌权限不变，FB 上仍存在，可随时重新导入）。',
    unmanaged: '已移除纳管',
    updated: '已更新',
    updateFail: '更新失败',
    assetReadPartial: '部分资产读取失败：{msg}',
    assetReadPartialShort: '部分资产读取失败：',
    assetReadFail: '读取失败',
    unknown: '未知',
    userAssets: '用户资产',
    fetchFail: '拉取失败：',
    importedCount: '导入 {n}',
    skippedExisting: '跳过已存在 {n}',
    notFound: '未找到 {n}', readonlyRejected: '{n} 个账户（{names}）未授权投放，未导入——请在 Facebook 商务管理平台（BM）为令牌补「广告投放」权限后重新导入',
    notFoundTitle: '部分 ID 未识别',
    notFoundDetail: '未找到 {n} 个：{ids}——请核对 ID，或确认账户已分配给已绑定的某个令牌。',
    importFail: '导入失败：',
    selectUnimported: '勾选未导入的账户',
    pasteIds: '粘贴账户 ID',
    deleted: '已删',
    startOAuthFail: '启动授权失败：',
    oauthUrlTitle: 'Facebook 授权链接',
    copyOAuthUrl: '复制授权链接', openInBrowser: '在本浏览器打开',
    oauthLinkCopied: '授权链接已复制（30 分钟内有效），可粘贴到其他设备/已登录 FB 的浏览器打开',
    oauthPickHint: '在本浏览器直接授权，或复制授权链接到已登录 FB 的其他设备完成；授权后令牌自动导入',
    fillToken: '填 token',
    importedOk: '成功',
    updateTokenPrompt: '粘贴新的个人令牌（Access Token）：',
    updateTokenTitle: '更新令牌 · {name}',
    updateBtn: '更新',
    tokenTooShort: '令牌太短',
    tokenUpdated: '令牌已更新（{name}）',
    checking: '检测中…',
    checkFail: '检测失败',
    deleteTokenConfirm: '删除「{name}」？名下关联账户将全部解绑，巡检/止损/哨兵对这些账户即刻停止覆盖，须重新授权才能恢复。',
    connectFacebook: '连接 Facebook',
    importAccounts: '导入账户',
    atRiskSummary: '{n} 个账户缺少可用令牌，暂无法读写',
    collapse: '收起 ▲',
    viewDetail: '查看 ▼',
    prevBound: '原绑 {name}',
    unboundToken: '未绑定令牌',
    unbound: '未绑定',
    fbUser: 'FB 用户', createdBy: '归属人',
    colAccounts: '账户',
    colPages: '主页',
    type: '类型',
    unnamed: '未命名',
    accountsCountTip: '已导入账户数',
    rotatePoolTip: '参与多令牌轮换候选池',
    checkValidity: '检测有效性',
    updateKey: '更新令牌',
    refreshAccounts: '刷新账户',
    deleteToken: '删除令牌',
    emptyTitle: '还没有绑定 Facebook 令牌',
    emptyStep: '点上方「添加令牌」或「连接 Facebook」开始 —— 绑定后才能载入广告账户、跑巡检止损。',
    emptyStep1: '连接 Facebook 令牌（OAuth 授权或手动粘贴）',
    emptyStep2: '载入广告账户（勾选导入纳管）',
    emptyStep3: '看板自动出数，巡检/止损开始运行',
    importThisToken: '导入本令牌账户', importGlobalTitle: '导入账户 · 全部令牌', importScopedTitle: '导入账户 · {name}',
    tokenName: '令牌名称',
    typeSource: '类型 / 来源',
    lastVerified: '最近检测',
    consecutiveFails: '连续失败',
    times: '次',
    linkedAccounts: '关联账户',
    importedUnit: '个（已导入）',
    permCount: '权限数',
    items: '项',
    tabAccounts: '广告账户',
    tabPages: '主页',
    tabPerm: '权限详情',
    tokenWarn: '⚠ 此令牌当前不可用（{status}），名下账户暂无法读写——建议检测令牌，或用可用令牌重新导入绑定。',
    addAccount: '添加账户',
    clickToCopy: '点击复制',
    balanceLabelTip: '可用额度 = 花费上限 − 历史总消耗；「不限额」= 未设花费上限',
    unmanage: '移除纳管',
    noImportedAccounts: '暂无已导入账户——点上方「导入账户」载入',
    fans: '粉丝',
    renameBtn: '重命名', categoryBtn: '改类型', categoryPh: '搜索或输入主页类别', pageCategoryPrompt: '新的主页类别（如 Internet Marketing Service，将真实修改 FB 主页类型；需主页管理权限）', pageCategoryLimit: '1-120 字符', pageCategorySaved: '主页类别已更新',
    maxAccountsBtn: '账户数上限', maxAccountsPrompt: '该令牌最多绑定多少个账户（当前已绑 {n} 个，现为 {cur}）。留空 = 不限。可写令牌建议 ≤100，账户过多会显著拖慢巡检。', maxAccountsLimit: '留空或 1-5 位数字', maxAccountsUnlimited: '不限',
    importBigBatchConfirm: '本次将导入 {n} 个账户——大量账户会显著增加巡检耗时与接口调用量，且可写令牌有绑定上限（超额账户会被跳过）。确定继续？',
    skippedOverLimit: '有 {n} 个账户因令牌绑定上限被跳过（调上限或换令牌后重导）',
    readonlyTitle: '仅 BM 可读账户',
    pageRenamePrompt: '新的主页名称（将真实修改 Facebook 主页名）',
    pageRenameLimit: '名称需 1-100 字符',
    pageRenamed: '主页已重命名',
    changeTypeBtn: '切换令牌类型',
    tokenTypeConfirm: '将令牌从「{from}」切换为「{to}」？切换后建广告/止损等操作由可写令牌执行',
    tokenTypeSaved: '令牌类型已切换',
    ttmanage: '管理', ttoperate: '可写',
    noPages: '无主页',
    viewMembersBtn: '查看成员',
    manageAssetsBtn: '管理资产',
    bmMemberNoTitle: '（未设职称）',
    bmFull: '完全控制', bmEmployee: '普通成员',
    bmNoMembers: '无可查看的成员（需要 BM 管理员权限）',
    bmNoAccounts: '该 BM 下没有可查看的广告账户',
    bmOwned: 'BM 自有', bmClient: '代理客户', bmManaged: '已纳管',
    bmPagesLine: '另有 {n} 个主页',
    noBM: '无 BM',
    bmFullControl: '完全控制',
    permDetailTitle: '权限（{n}）',
    userId: '用户 ID',
    tabChecklist: '勾选清单',
    tabIdImport: 'ID 导入',
    searchAccountPlaceholder: '模糊搜索：账户名或 ID',
    loadableMeta: '共 {total} 个可管理账户，已选 {selected}',
    importedMark: '已导入', prevManagedMark: '曾纳管·可恢复',
    tokenAvailable: '该令牌可用',
    tokenUnavailable: '该令牌不可用（冷却/限流）',
    noMatchAccounts: '无匹配账户',
    importSelected: '导入选中',
    idImportHint: '粘贴账户 ID，每行一个或用逗号/空格分隔。',
    idImportScopedHint: '仅在令牌「{name}」下识别。',
    idParseLine: '识别 {n} 个 · 去重后 {m} 个',
    idParseDedup: '已去重 {k} 个',
    idParseTooMany: '超过 200 个，请分批导入',
    tabOauth: 'OAuth 授权',
    tabManual: '个人令牌',
    oauthHint: '先在「配置 App」添加 App。',
    systemApp: '系统', primaryApp: '主',
    myApp: '我的',
    manualWarn: '⚠ 无法自动续期，建议用 OAuth。',
    accessTokenPlaceholder: '访问令牌（Access Token）',
    aliasOptional: '名称（可选）',
    optOperate: '可写令牌（写广告 + 读 + 可暂停）',
    optManage: '管理令牌（读 + 可暂停，不建新广告）',
    optUser: '只读令牌（仅查看，不可暂停）',
    scopeAdsManagement: '广告管理',
    scopeAdsRead: '广告读取',
    scopePagesShowList: '主页展示',
    scopePagesMessaging: '主页消息',
    scopePagesManageMetadata: '主页管理元数据',
    scopePagesReadEngagement: '主页读取互动',
    scopePagesManagePosts: '主页管理帖子',
    scopePagesReadUserContent: '主页读取用户内容',
    scopePagesManageEngagement: '主页管理互动',
    scopePagesEvents: '主页事件',
    scopeBusinessManagement: '商务管理平台',
    scopeReadInsights: '读取分析',
    scopeInstagramBasic: 'Instagram 基础',
    scopeInstagramManageInsights: 'Instagram 管理分析',
    scopeInstagramManageComments: 'Instagram 管理评论',
    scopePublicProfile: '公共主页资料',
    scopeEmail: '邮箱',
    scopeAttributionRead: '归因读取',
    scopeCatalogManagement: '目录管理',
    scopeWhatsappBusinessManagement: 'WhatsApp 商务管理',
    scopeLeadsRetrieval: '潜在客户检索',
    scopePagesManageCta: '主页管理 CTA',
    dataHealth: '数据健康',
    healthTitle: '令牌 / 账户数据健康',
    healthMeta: '扫描 {creds} 个令牌 · {accounts} 个账户 · {links} 条关联 · {th} 条健康记录 · TikTok 令牌 {ttc} / TikTok 关联 {ttl}',
    healthLoadFail: '数据健康扫描失败',
    healthAllClean: '未发现异常数据',
    healthCleanBtn: '清理失效关联',
    cleaning: '清理中…',
    cleanConfirm: '将清理失效的令牌关联记录（可重复执行），不会删除令牌或账户本身。确定清理？',
    cleanDone: '清理完成：删 {afc} 条失效关联 · {th} 条健康记录 · 重置 {cred} 个主令牌 · 修正 {tt} 个令牌类型 · 删 TikTok 关联 {ttc} 条 · 重置 TikTok 主令牌 {ttp} 个',
    hCleanable: '可清理',
    hManualOnly: '仅报告',
    hIssueCredBadStatus: '令牌状态值异常',
    hIssueCredBadTokenType: '令牌类型值异常',
    hIssueAccountDanglingCred: '账户的主令牌已删除或不可用',
    hIssueAfcDangling: '令牌关联记录失效（账户或令牌已删除）',
    hIssueAfcTenantMismatch: '关联记录归属异常',
    hIssueAfcBadStatus: '关联记录状态值异常',
    hIssueTokenHealthDangling: '令牌健康记录失效（令牌已删除）',
    hIssueAccountEmptyActid: '账户缺少账户 ID',
    hIssueTtCredBadStatus: 'TikTok 令牌状态值异常',
    hIssueTtAccountDanglingCred: '账户的 TikTok 主令牌已删除或不可用',
    hIssueTtcDangling: 'TikTok 令牌关联记录失效或归属异常',
    hIssueTtcBadStatus: 'TikTok 关联记录状态值异常',
    // TikTok 分区
    connectTikTok: '连接 TikTok',
    ttLoadFail: 'TikTok 令牌加载失败',
    ttStartFail: '启动 TikTok 授权失败：',
    ttEmptyTitle: '还没有 TikTok 令牌',
    ttEmptyHint: '点「连接 TikTok」跳转授权，授权主体下的全部广告账户自动导入。',
    ttAutoNote: 'Access Token 24 小时过期，系统每 6 小时自动刷新；Refresh Token 有效期 365 天，到期前 30 天会提醒重新授权。',
    ttAccessExpires: 'Access 到期',
    ttExpiredNow: '已过期',
    ttInHours: '{n} 时',
    ttInMinutes: '{n} 分',
    ttLastRefresh: '自动刷新',
    ttRefreshLeft: 'Refresh 剩余',
    ttDaysUnit: '{n} 天',
    ttReauth: '重新授权',
    ttReauthTip: 'Refresh Token 30 天内到期，请尽快重新授权（过期后无法自动续期）。',
    ttLinkedAccounts: '账户',
    ttAppTitle: 'TikTok App 配置',
    ttAppHint: '系统级 App，超管配置一次全团队共用。当前 App ID：{appId}',
    ttAppNotConfigured: '未配置',
    ttAppIdPh: 'App ID',
    ttAppSecretPh: 'App Secret',
    ttAppSave: '保存',
    ttAppSaved: '已保存',
    ttAppFillBoth: 'App ID 和 App Secret 都要填',
    ttAppsTitle: 'TikTok App', ttAddApp: '添加 App', ttAppNamePh: 'App 名称（可选）',
    ttNoAppsGoSettings: '暂无 App——管理员在 设置 → 应用配置 添加', ttNoAppsSuper: '还没有配置 TikTok App——点右上「添加 App」填入开发者后台的 App ID / Secret',
    ttNoAppsUser: '尚未配置 TikTok App，请联系平台管理员配置',
    ttAppDeleteConfirm: '删除 App「{name}」？（使用中的令牌不受影响，但无法再发起新授权）',
    ttLoadHint: '仅显示已授权但未纳管的 TikTok 账户，勾选后导入纳管。',
    ttNoLoadable: '无可载入账户（先「连接 TikTok」授权）',
    ttCoverToken: '授权令牌',
    ttImportedGoAds: '已导入 {n} 个 TikTok 账户，去广告账户页查看？',
    fbImportedGoAds: '已导入 {n} 个账户，去广告账户页查看？',
    goAdsPage: '去广告账户页',
    ttRefreshNow: '立即刷新',
    ttRefreshedNow: '已刷新，Access 约 {h} 小时后到期',
    ttRefreshFail: '刷新失败：',
    ttDeleteConfirm: '删除 TikTok 令牌「{name}」？',
    ttDeleteWarning: '令牌删除后其关联的 TikTok 账户保留（解除绑定、不再自动续期），重新授权可再绑定。',
  },
  audit: {
    tabAll: '全部',
    tabUser: '操作',
    tabSystem: '系统',
    tabLogin: '登录',
    tabFail: '失败',
    fieldAction: '动作',
    actionPlaceholder: '选择动作（可输入筛选）',
    actionKeepaliveBurnt: '保活暂停', actionBudgetProgress: '预算进度告警', actionWarmupDisarm: '保活名单移出', actionStaleAccounts: '停滞账户标记', actionSubcodeCleanup: '子码清理', actionAssign: '分配', actionUnassign: '取消分配', actionAllowance: '加白', actionAllowanceRemoved: '解除加白', actionEmergencyPause: '紧急暂停', actionPurgeStalePages: '停滞主页清理', actionKeepaliveSetPage: '指定保活主页', actionSetMaxAccounts: '设置绑定上限', actionPageHealth: '主页健康检查', actionPageUnavailable: '主页不可用告警', actionAiQuota: 'AI 配额用尽', actionAdjust: '余额调整', actionCreatePixel: '新建像素', actionStormSuppressed: '告警合并', actionPruneHashCache: '素材缓存清理', actionTokenHealthWarn: '令牌健康预警', actionManualBudget: '手动改预算', actionUpsert: '保存', metaAct: '账户', metaAd: '广告', metaPage: '主页', metaCred: '令牌', metaCampaign: '系列', metaTeam: '团队', metaOld: '原值', metaNew: '新值', metaReason: '原因', metaBudget: '预算', metaSpend: '消耗', metaBalance: '余额', metaCount: '数量', metaPagesMismatch: '主页不匹配', metaStatus: '状态', metaTemplate: '模板', metaJob: '任务', metaSlug: '子码', actionImport: '导入账户',
    fieldUser: '用户',
    fieldTrace: '链路',
    tracePlaceholder: 'trace_id 拉全链路',
    fieldDate: '日期',
    dateStart: '开始',
    dateEnd: '结束',
    clear: '清除',
    pagerInfo: '共 {total} 条 · 第 {page} / {pages} 页',
    prevPage: '上一页',
    nextPage: '下一页',
    jumpPh: '页码',
    jumpGo: '跳转',
    traceLabel: '链路',
    traceCount: '{n} 条',
    traceEmpty: '该链路无更多记录',
    colTime: '时间',
    colType: '类型',
    colAction: '动作',
    colTarget: '对象',
    colTeam: '团队',
    colResult: '结果',
    resultSuccess: '✓ 成功',
    resultFail: '✗ 失败',
    typeUser: '用户',
    typeSystem: '系统',
    typeSentinel: '哨兵',
    typeSync: '同步',
    typeWarmup: '保活',
    actionInspectionHeartbeat: '巡检心跳',
    actionPause: '止损暂停',
    actionDeploy: '广告部署',
    actionLogin: '登录',
    actionSwitchTenant: '切换团队',
    actionAccountPermissionError: '令牌权限不足',
    actionTokenRateLimited: '令牌限流',
    actionLandingHealthAlert: '落地页告警',
    actionCoverageLost: '覆盖丢失',
    actionCreate: '创建',
    actionUpdate: '更新',
    actionDelete: '删除',
    actionArchive: '归档',
    actionRulePause: '规则止损',
    actionSentinelPause: '哨兵暂停',
    actionEmergencyPause: '紧急暂停',
    actionTokenExpired: '令牌过期',
    actionTokenInvalid: '令牌失效',

    // 批CD：日志动作/目标/来源全量 i18n（生产实际出现的枚举）
    actionKeepalive: '保活建广告', actionOrphanAccountAlert: '失联账户告警', actionLowBalanceAlert: '额度不足告警',
    actionRulePauseNotified: '规则停已通知', actionLiveFetchDegraded: '数据拉取降级', actionAccountStatusChange: '账户状态变更',
    actionInspectionStalledAlert: '巡检停滞告警', actionManualPaused: '手动暂停', actionManualActive: '手动开启',
    actionGroupUpdate: '广告组更新', actionAiAnalyze: 'AI 分析', actionAiEdit: 'AI 文案编辑',
    actionSentinelFailureAlert: '哨兵失败告警', actionSentinelArm: '哨兵布防', actionSentinelDisarm: '哨兵解除',
    actionSentinelAutoArmed: '哨兵自动开启（无交互超时）', actionSentinelAutoArmWarning: '哨兵倒计时预警',
    actionSentinelPermDenied: '哨兵权限拒绝', actionSentinelBatchAlert: '哨兵批量停告警',
    actionUnmanage: '移除纳管', actionHardDelete: '永久删除', actionWarmupArm: '开启保活',
    actionInspectionSkipped: '巡检跳过', actionUpdateToken: '令牌更新', actionUpload: '上传',
    actionRename: '重命名', actionSyncStalled: '同步停滞', actionRestore: '恢复', actionSpendSpike: '消耗骤变',
    targetTenant: '团队', targetAsset: '素材', targetCampaign: '系列', targetSystemSetting: '系统设置',
    targetSync: '同步任务', targetLandingTemplate: '落地页模板', targetAudience: '受众', targetLead: '潜客', targetPage: '主页',
    sourceAccountSync: '账户同步', sourceCfApi: '域名服务', sourceKeepalive: '保活引擎', sourceAdOps: '广告操作',
    sourceAuth: '认证', sourceAiVision: 'AI 视觉', sourceAdsCacheSync: '缓存同步', sourceAdmin: '管理后台',
    sourceEmergencyPause: '紧急暂停', sourceKpiResolver: 'KPI 解析', sourceSentinelPatrol: '哨兵巡逻',

    targetScheduler: '调度器',
    targetAd: '广告',
    targetAccount: '账户',
    targetFbCredential: '令牌',
    targetLandingPage: '落地页',
    targetLaunchTemplate: '投放模板',
    targetLaunchJob: '部署任务',
    targetFormTemplate: '表单模板',
    targetUser: '用户',
    targetTeam: '团队',
    targetSubcode: '子码',
    targetRule: '规则',
    sourceScheduled: '定时任务',
    sourceRuleEngine: '规则引擎',
    sourceFbApi: 'FB接口',
    sourceGuard: '规则引擎',
    sourceLanding: '落地页',
    sourceLaunch: '广告部署',
    sourceSentinel: '哨兵',
    sourceWatchdog: '任务监控',
    sourceUser: '用户操作',
    sourceWarmup: '保活',
    sourceSync: '数据同步',
  },
  members: {
    tabMembers: '团队成员',
    tabRoles: '角色权限',
    memberCount: '{n} 个成员',
    inviteMember: '邀请成员',
    colMember: '成员',
    colRole: '角色',
    you: '你',
    permCount: '{n} 权限',
    roleCount: '{n} 个角色',
    createRole: '新建角色',
    systemTag: '系统',
    permCountLabel: '{n} 个权限',
    memberCountLabel: '{n} 人',
    editPerms: '编辑权限',
    noPerms: '无权限',
    editRole: '编辑角色',
    roleName: '角色名',
    roleNamePlaceholder: '如：落地页专员',
    description: '描述',
    descriptionPlaceholder: '角色说明（可选）',
    permMatrixTitle: '权限矩阵（勾选该角色可以使用的模块）',
    selectedPerms: '已选 {n} 个权限',
    email: '邮箱',
    emailPlaceholder: '新成员邮箱',
    password: '密码',
    passwordPlaceholder: '留空=默认 Welcome123!',
    inviting: '邀请中…',
    invite: '邀请',
    loadFail: '加载失败',
    roleNameRequired: '填角色名',
    roleUpdated: '角色已更新',
    roleCreated: '角色已创建',
    systemRoleNoDelete: '系统角色不可删除',
    roleHasMembers: '该角色下有成员，请先转移',
    delRoleConfirm: '删除角色「{name}」？',
    doneSuffix: '已删除',
    emailRequired: '填邮箱',
    invitedWithPwd: '已邀请，默认密码：{pwd}（请告知对方首次登录后修改）',
    invited: '已邀请',
    inviteSuccess: '邀请成功',
    roleChange: '角色变更',
    changeRoleFromOwner: '将 {email} 从【管理员】改为【{role}】？\n\n管理员降级会立即收回其管理权限（含改规则/改配置/邀人）。',
    changeRole: '将 {email} 的角色改为【{role}】？',
    removeMemberConfirm: '移除成员「{email}」？', resetPwd: '重发密码', resetPwdConfirm: '为 {email} 生成新的临时密码？旧密码立即作废，成员首次登录需改密。', resetPwdDone: '新临时密码：{pwd} —— （请立即复制发给成员，此窗口不会再次显示）',
    removed: '已移除',
    deleted: '已删除',
    perm: {
      adsRead: '看广告',
      adsCreate: '建广告',
      adsPause: '停广告',
      adsResume: '开广告',
      adsUpdate: '改广告',
      adsDelete: '删广告',
      rulesRead: '看规则',
      rulesCreate: '建规则',
      rulesEdit: '改规则',
      landingManage: '投放链接',
      assetsManage: '素材库',
      billingView: '看账单',
      billingManage: '管账单',
      membersInvite: '邀成员',
      membersManage: '管成员',
      auditRead: '审计',
    },
  },
  settings: {
    pageTitle: '设置', pageMeta: '账号 · 通知 · 调度 · 系统',
    tzShanghai: '北京/上海', tzHongKong: '香港', tzTaipei: '台北', tzTokyo: '东京',
    tzSeoul: '首尔', tzSingapore: '新加坡', tzBangkok: '曼谷', tzJakarta: '雅加达',
    tzMumbai: '孟买', tzLosAngeles: '洛杉矶', tzNewYork: '纽约', tzSaoPaulo: '圣保罗',
    tzLondon: '伦敦', tzParis: '巴黎', tzSydney: '悉尼',
    tzSwitched: '已切换，所有时间按此时区显示',
    copyFailManual: '复制失败，请手动选中复制',
    saveFail: '保存失败：{msg}',
    taskInspect: '巡检（止损评估）', taskWatchdog: '令牌健康检查',
    taskAccountSync: '账户状态/余额', taskBudget: '预算进度告警',
    taskReassociate: '失效账户重绑', taskSubcode: '子码自动绑定', taskSentinel: '哨兵巡逻',
    sentinelChangeMsg: '哨兵巡逻间隔将改为 {n} 分钟，确认？',
    sentinelChangeTitle: '哨兵间隔变更',
    baseChangeMsg: '基础间隔改为 {n} 分钟？这是所有定时任务（巡检/预算/任务监控等）的频率基数，会全局影响止损/告警的响应速度。',
    baseChangeTitle: '基础间隔变更', confirmChange: '确认变更',
    aiPresetGemini: 'Gemini（OpenAI 兼容）', noChange: '无变更',
    textModelOk: '文案模型：{detail}', textModelFail: '文案模型失败：{detail}', testFail: '测试失败',
    visionModelOk: '视觉模型：{detail}', visionModelFail: '视觉模型失败：{detail}',
    invalidEmail: '填有效邮箱', fillOldPwdForEmail: '改登录邮箱需先输入当前密码确认', emailUpdated: '用户名已更新，下次登录用新邮箱',
    opFail: '失败：{msg}',
    fillOldNewPwd: '填旧/新密码', pwdMismatch: '两次新密码不一致', pwdMinLen: '新密码至少 8 位',
    pwdUpdatedRelogin: '密码已更新，请用新密码重新登录',
    tgBindOk: 'TG 绑定成功：{name}', tgBindFail: 'TG 绑定失败',
    tgTestSentUser: '测试消息已发送到你的 TG', sendFail: '发送失败',
    tgTestSentTenant: '测试消息已发送到团队 TG', tgTestFailTenant: '发送失败（管理员未绑团队 TG）',
    fillChatId: '填 chat_id', bound: '已绑定', bindFail: '绑定失败',
    tgUnbindConfirm: '确定解绑 TG？解绑后不再收到 TG 告警通知。', tgUnbound: '已解绑',
    fxUpdated: '已更新 {n} 个币种汇率', fetchFail: '拉取失败：{msg}',
    retentionShrinkItem: '{label} {from}→{to}天',
    retentionShrinkMsg: '以下数据保留天数被调小，下次清理（每日 4:33）将删除超龄记录：\n{detail}\n\n确定？',
    retentionShrinkTitle: '保留策略收紧 · 将删数据', confirmShrink: '确认收紧',
    retentionSaved: '保留策略已保存（每日 4:33 自动清理）',
    retentionCleanItem: '{table} 删除 {n} 条', retentionCleanDone: '清理完成 · {detail}', cleanFail: '清理失败：{msg}', retentionRunTitle: '立即清理数据', retentionRunConfirm: '按当前保留策略立即删除过期数据（落地页日志/操作日志/巡检历史等）——删除不可恢复。确定执行？', retentionRunBtn: '确认清理',
    keepaliveEnabled: '保活已全局开启',
    kaRunNow: '立即扫描一次', kaRunHint: '扫描中（约 10~60 秒），完成后自动弹出结果', kaResultTitle: '保活扫描结果', kaBuilt: '新建', kaSkipped: '跳过', kaFailed: '失败', kaSuccess: '成功', kaSkip: '跳过', kaFail: '失败', kaNoAccounts: '没有符合条件的账户',
    accountTitle: '账号',
    grpPersonal: '个人', grpPlatform: '平台', grpAutomation: '调度与自动化', grpIntegrations: 'AI 与集成', grpBilling: '计费与域名',
    accountDesc: '登录用户名（邮箱）和密码。修改密码后需用新密码重新登录。',
    username: '用户名', loginEmailPh: '登录邮箱', saveUsername: '保存用户名', acctEmailTitle: '修改登录邮箱', changePwdTitle: '修改密码', displayNameTitle: '展示名', displayNamePh: '便于识别的名称（如：张三），留空则用邮箱前缀',
    oldPwd: '旧密码', currentPwdPh: '当前密码', newPwd: '新密码', pwdMin8Ph: '至少 8 位',
    confirm: '确认', pwdMismatchPh: '两次不一致', reenterNewPwdPh: '再次输入新密码', changePwd: '修改密码',
    tzTitle: '系统显示时区', tzDesc: '系统各项时间的显示时区。',
    tzSearchPh: '搜索城市或输入时区名（如 Asia/Shanghai）', tzOption: '{label}（{tz}）',
    scheduleTitle: '任务调度', scheduleDesc: '各自动任务的执行频率。',
    baseBeat: '基础节拍', minutes: '分钟', taskCol: '任务', multiplierCol: '倍数', effectiveCol: '生效',
    minSuffix: '{n} 分钟', saveAndApply: '保存并生效',
    gtTitle: '巡检与告警', gtDesc: '止损巡检与告警的平台级参数，对所有团队生效。',
    gtParamCol: '参数', gtValueCol: '当前值', gtDescCol: '说明',
    gtConc: '巡检并发',
    gtConcHint: '同时巡检的广告账户数：调大更快，但对平台压力越大。默认 {d}（可填 1-8）。',
    gtLearn: '学习期保护',
    gtLearnHint: '创建不足 N 小时的新广告暂不停投，给 FB 系统学习期。默认 {d} 小时。填 0 = 关闭保护。',
    gtStorm: '告警风暴上限',
    gtStormHint: '每个团队每天同一类告警最多发 N 条，超出部分当天静默，防刷屏。默认 {d} 条。填 0 = 不封顶；保存后 1 分钟内生效。',
    gtFillAll: '三个参数均为必填整数', gtRange: '需为 {min}-{max} 之间的整数',
    aiTitle: 'AI 配置',
    aiDesc: 'AI 服务配置（文案 / 视觉双模型）。',
    aiTextModelTitle: '文案模型（KPI / 文案生成）', provider: '服务商',
    providerPh: '选服务商或填 Base URL', providerOpt: '{label}（{url}）',
    fillNewKeyPh: '填新 key 覆盖', modelPh: '选模型或填模型名',
    aiVisionModelTitle: '视觉模型（素材 AI 识别，看图）',
    aiVisionDesc: '用 Gemini 等视觉模型。DeepSeek 纯文本看不了图，所以素材识别单独配这里。',
    testText: '测试文案', testVision: '测试视觉',
    cfTitle: 'Cloudflare 管理',
    cfMainTitle: 'Tova 系统主 CF',
    cfMainScope: '系统专用',
    cfMainHint: '只管 tovaads.com 域名、邮箱路由、前端部署与 alphatx——绝不操作落地页（落地页一律走下方专用账户）。',
    cfPermStep: '建 Token：CF Dashboard → My Profile → API Tokens → Create Token（Custom token），账户选「落地页专用账户」，权限照下表勾选：',
    cfPermAcc: '账户级',
    cfPermZone: '区域级 · All zones',
    cfPermOpt: '可选',
    cfPermNote: '权限名与 CF 后台一致；「Zone — Edit」在区域(Zone)分类里，作用域选 All zones（含未来新建域名）。贴入后点「测试连接」三项全绿即可用。',
    cfLandingTitle: '落地页专用 CF',
    cfLandingNotSet: '未配置——落地页功能当前不可用',
    cfLandingActive: '已启用',
    cfLandingHint: '落地页全家桶（域名 zone / Pages 部署 / 子域名绑定 / 域名商店建 zone）只走此专用账户，主 key 不操作落地页；未配置时上述功能一律明确报错。',
    cfLandingClear: '清除配置',
    cfLandingClearConfirm: '清除落地页专用 CF 配置？清除后落地页相关功能将不可用（可随时重新配置）。',
    cfTestBtn: '测试连接',
    cfViewLabel: '管控台视角',
    cfScopeMain: '主账户',
    cfScopeLanding: '落地页账户',
    cfOnboardTitle: '接入外部域名', cfOnboardPh: '在别处购买的域名，如 mybrand.com', cfOnboardBtn: '接入',
    cfOnboardOk: '域名 {d} 已加入 CF——请到注册商把 NS 改为下面两台（改完回到这里刷新看状态变 active）',
    cfOnboardNsHint: '到你的域名注册商 → DNS/Nameserver 设置 → 替换为以下 CF NS（点即复制）：',
    cfZonesTitle: '域名', cfPagesTitle: 'Pages 项目', cfNoZones: '暂无域名', cfNoRecords: '无 DNS 记录', cfLpLink: '关联的落地页',
    pbTitle: 'Porkbun 域名代购', pbDesc: '域名商店注册商凭据（porkbun.com → Account → API Access 创建）。', pbTest: '测试连接', pbTestOk: '连接成功（{a}）', pbHint: '配置后「落地页 → 购买域名」自动激活：查价/下单/注册/接入 CF 全自动。',
    rgPayMoved: '收款/打款配置已移至独立的「支付设置」分区。', rgTitle: '域名注册商', rgDesc: '域名商店代购注册商：Dynadot（推荐，支持支付宝充值账户余额，API 从余额扣费）/ Porkbun（美元卡）。', rgSelect: '当前注册商', rgVerified: '已验证 ✓ {v}', rgUnverified: '已配置·未验证（点下方测试连接）', rgReady: '已配置', rgNoKey: '未配置凭据', rgDdHint: 'Dynadot 新版 REST API 是密钥对：Tools → API 生成「API 生产密钥」+「密钥(Secret)」，两把都填（Secret 用于注册/账户读取的签名）。注册前需在 Dynadot 预存余额（支付宝可充）。', rgSecretPh: '「密钥(Secret)」——与 API 生产密钥同页生成', rgFee: '代购手续费（美元）', rgFeePh: '当前 ${v}，输入新值修改', rgFeeFixed: '固定', rgFeePercent: '比例+保底', rgFeeFixedAmt: '固定手续费($)', rgFeeRate: '比例(%)', rgFeeRatePh: '当前 {v}%，输入新值修改', rgFeeFloor: '保底($)', rgFeeFloorPh: '当前 ${v}，输入新值修改', rgFeeRuleHint: '比例模式：手续费 = max(保底, 比例×域名成本)——便宜域名走保底统一价，贵域名按比例。', rgPayTitle: 'USDT 收款（全站暂统一 USDT）', rgPayChain: '链', rgPayChainPh: '如 TRC20 / ERC20', rgPayAddr: '收款地址', rgPayAddrPh: '每行一个地址（TRC20）', rgPayAddrNewPh: '每行一个地址，保存后覆盖（留空保持不变）', payPoolPh: '每行一个地址（TRC20），保存后覆盖；留空保持不变', payPoolNote: '共 {n} 个收款地址，订单按顺序分配', payAddrChange: '更换地址', payShowQr: '二维码', payHideQr: '收起二维码', payTitle: '支付设置', payDesc: '全站统一 USDT-TRC20 收款。链上自动到账监听用 TronGrid（Tron 官方 API）——零抽成、无第三方网关。', payReady: '收款地址已配置', payNoAddr: '未配置收款地址', tgKeyPh: 'trongrid.io 免费申请', tgKeyHint: 'TronGrid API Key 非必填（免 key 有更低限流）；在 trongrid.io 注册后在 Dashboard → API Keys 生成。', payNoteLabel: '打款说明（给客户看）', payNotePh: '如：转账请备注订单域名，到账后自动确认', rgPayHint: '配置后域名订单页会显示收款地址，客户按地址转 USDT、管理员确认收款。', rgFeeHint: '域名商店每单加收的服务手续费，展示在候选列表与订单价格中。', rgDynadotKeyPh: 'Tools → API 生成', rgTestOk: '连接成功（{a}{b}）',
    cfAccountNsTip: '注册商 NS 改为这两台（个别域名可能不同，以接入后返回为准）', cfPendingHint: 'NS 未生效，去注册商确认',
    cfUsageTitle: '用量与限额', cfToday: '今日',
    cfLimitsLine: 'Free 档参考：静态请求 {a} · 带宽 {b} · Functions 调用 {c}/天 · 构建 {d}/月（付费档上调，以套餐为准）',
    cfUnlimited: '不限', cf100k: '10万',
    cfPermHint: '访问量权限仍缺失（CF 实测）：缺 {perm}。CF 后台 → My Profile → API Tokens → 找【尾号 {tail}】的这把 Token（务必同一把）→ Edit → 添加 Zone › Analytics › Read（是 Zone 级，不是 Account 级）→ Zone Resources 含 All zones → 保存后点 ⟳ 立即重试。', cfTokenTailTip: '当前使用的 CF API Token 尾号（改权限须改这把）', cfUsageTotal: '合计',
    cfUvRt: '近实时（分钟粒度）', cfSparkTip: '近30天请求趋势（不含今日）',
    cfReconTitle: '域名对账（CF ↔ 域名库）', cfReconOk: '全部一致 ✓', cfReconCfOnly: 'CF 有 zone 但域名库未登记', cfReconLibOnly: '域名库已登记但 CF 无 zone',
    cfUvToday: '今日请求数 · 独立访客（CF 按日聚合，今日数据延迟数小时属正常）',
    cfEmailTokenLabel: '邮箱管理 Token（可选）', cfEmailTokenPh: '用户级 API Token（cfat_ 开头的账户级不行）',
    cfTokenNameLabel: '令牌名称（备注）', cfTokenNamePh: '如 Tovaads——与 CF 后台 token 同名，多把时好辨认',
    cfEmailTokenHint: 'Email Routing 的目的地邮箱/转发规则管理只支持用户级 API Token。CF 后台 → My Profile → API Tokens → Create Token：Zone·tovaads.com 的 Email Routing Addresses·Edit + DNS·Edit + Zone·Read。只做启用/DNS 可不填。',
    emNeedUserToken: '⚠ 目的地邮箱/转发规则管理需要用户级 CF Token——去「域名服务配置」填「邮箱管理 Token」后刷新（启用和 DNS 配置不受影响）。',
    cfDesc: '平台域名服务凭据。',
    emTitle: '邮箱转发',
    emDesc: "把 {domain} 的域名邮箱转发到你的真实邮箱（CF Email Routing 全自动）。",
    resendTitle: '发信服务',
    resendDesc: '注册验证、密码重置等系统邮件的发送服务。',
    resendKeyLabel: 'Resend API Key', resendKeyPh: '在 resend.com 生成',
    resendReady: '已配置', resendNoKey: '未配置',
    resendKeyHint: '在 resend.com 注册并验证发件域名后生成 API Key，用于发送验证/重置邮件。',
    resendTestToPh: '测试收件邮箱', resendTest: '发测试邮件',
    resendTestOk: '测试邮件已发送到 {to}', resendTestToRequired: '请填测试收件邮箱', resendKeyRequired: '请填 Resend API Key',
    emStatusUnconfigured: '未启用',
    emStatusEnabled: '已启用',
    emStatusDisabled: '已停用',
    emDnsReady: 'DNS 已就绪',
    emDnsMissing: '缺 {n} 条 DNS 记录',
    emEnableBtn: '启用并自动配置 DNS',
    emFixDnsBtn: '补齐缺失的 DNS 记录',
    emEnabling: '启用中…',
    emEnabledMsg: 'Email Routing 已启用，补了 {n} 条 DNS 记录',
    emEnableHint: '启用需要 3 条 MX + 1 条 SPF TXT 记录，会自动对比现有 DNS 并只补缺失的。',
    emDestTitle: '目的地邮箱',
    emDestDesc: '邮件最终送达的真实邮箱。添加后 CF 会发验证邮件，到该邮箱点开链接完成验证后才能用于转发。',
    emAddrPh: "you{'@'}example.com",
    emAddrInvalid: '邮箱地址格式不对',
    emAddrAdded: '已添加，验证邮件已发送——去该邮箱点验证链接',
    emAddrExisted: '该邮箱已添加过（以上方验证状态为准）',
    emAddrVerified: '已验证',
    emAddrPending: '待验证 · 去邮箱点验证邮件',
    emAddrDelConfirm: '删除目的地邮箱 {email}？正在被映射引用时无法删除。',
    emNoAddrs: '暂无目的地邮箱',
    emRouteTitle: '转发映射',
    emRouteDesc: "域名别名 → 目的地邮箱。别名只收小写字母/数字和 . _ - （如 dev → dev{'@'}{domain}）。",
    emAliasPh: '别名，如 dev',
    emAliasRequired: '先填别名',
    emPickDestPh: '选已验证的目的地邮箱',
    emDestRequired: '先选目的地邮箱',
    emRouteAdd: '添加映射',
    emRouteAdded: '映射已创建，发往该地址的邮件即刻转发',
    emRouteDelConfirm: '删除转发 {alias}？该地址将无法收信。',
    emNoRoutes: '暂无映射',
    emDeleted: '已删除',

    faTitle: '应用配置', faDesc: '平台 App 管理（Facebook OAuth / TikTok 连接）。', faFbSubTitle: 'Facebook 应用', ttSubTitle: 'TikTok 应用（令牌页 TikTok 分区发起连接）', ttAdd: '+ 新建 TikTok App', ttEmpty: '暂无 TikTok App', ttAppIdPh: 'TikTok Sandbox/正式 App ID', ttDefaultTag: '默认', ttFillBoth: '请填写 app_id 和 app_secret', ttDeleteConfirm: '删除 TikTok App「{name}」？使用它授权的令牌将失效。',
    faAdd: '+ 新建 Facebook App', faAddTitle: '新建 Facebook App', faName: '名称', faNamePh: '如 Main App', faAppId: 'App ID', faSecret: 'App Secret', faEditTitle: '编辑 Facebook App',
    faSecretKeep: '留空 = 保持原 Secret 不变', faSystem: '系统级', faSystemOpt: '系统级 App（全团队共用，仅超管可建）',
    faFillBoth: 'App ID 和 Secret 必填', faDeleteConfirm: '删除 App {id}？使用它授权的令牌将无法续期，潜客推送的校验也将失效。', faEmpty: '暂无 App——点下方新建', faPrimary: '主', faBackup: '备', faSetPrimary: '设为主', faStop: '停用', faEnable: '启用', faInactive: '已停用', faStopConfirm: '停用 App {name}？已签发的令牌不受影响继续可用，仅不再用它签发新授权。', faStartConfirm: '启用 App {name}？',
    ibTitle: '账户导入行为', ibDesc: '统一控制载入账户弹窗与令牌上限的默认行为（超管）。',
    ibAllLabel: '载入账户弹窗默认全选未导入账户', ibCapLabel: '新可写令牌默认账户数上限：',
    ibCapPh: '100', ibCapNote: '授权新建的 operate 令牌默认绑定上限（0=不限）。已建令牌在令牌页 ⋯ 菜单逐个调整。', ibCapLimit: '需 0-10000 的数字',
    whTitle: 'FB 潜客实时推送',
    whDesc: 'FB 潜客实时推送（自动用已配 App Secret 校验）。',
    whCopyUrl: '复制 URL',
    whUrlCopied: 'Webhook URL 已复制',
    whActiveApps: '已配 {n} 个 App（用于校验推送）',
    whTokenLabel: 'Verify Token（FB 后台配 webhook 时填同一值）',
    whTokenPh: '设置 Verify Token',
    whTokenHint: '填新值覆盖（建议改强随机值）；留空保存=恢复默认。改完即生效。',
    whTokenReset: '已恢复默认值',
    whDefault: '默认',
    whCustom: '自定义',
    whResetDefault: '恢复默认',
    accountId: '账户 ID', fillNewTokenPh: '填新 token 覆盖',
    retentionTitle: '数据保留',
    retentionDesc: '各类历史数据的保留天数，到期自动清理（每日 4:33）。填 0 = 永久保留。账户/落地页/配置不清理。',
    retDataCol: '数据', retDaysCol: '保留天数', retDescCol: '说明',
    foreverKeep: '永久保留', delBefore: '{n} 天前删除', lastClean: '上次清理：{ts}',
    savePolicy: '保存策略', cleaning: '清理中…', cleanNow: '立即清理一次',
    fxTitle: '汇率（止损换算）',
    fxDesc: '非美元账户止损换算汇率，每日自动更新。',
    lastSync: '上次同步：{ts} UTC', fetching: '拉取中…', syncFxNow: '立即同步汇率',
    tgTitle: 'Telegram 通知',
    tgDesc: '绑定你的 Telegram 接收实时告警（止损/封禁/异常）。点击按钮打开 Telegram 机器人自动绑定。',
    tgAddAnother: '+ 绑定另一个 TG',
    tgBoundBadge: '✅ 已绑定 {id}', sending: '发送中…', sendTestMsg: '发送测试消息', unbind: '解绑',
    bindTelegram: '绑定 Telegram', bindLinkCopied: '绑定链接已复制', cannotOpenCopy: '打不开？复制链接',
    tgBotNotConfigured: '管理员未配置 TG Bot', verifyBotConfig: '验证 Bot 配置',
    tgManualHint: '按钮打不开/被墙？先给 Bot 发送 /start，把回复里的数字 ID 填到这里手动绑定',
    tgManualPh: 'Telegram 数字 ID（如 123456789）', tgManualBind: '手动绑定',
    tgManageBtn: '管理 Telegram 绑定（绑定/解绑/清单）',
    tgStartHint: '点按钮不会重发命令（与 Bot 的对话已存在时）——复制下方命令粘贴到 Bot 对话发送完成绑定（30 分钟内有效，「复制命令」每次得新码）：',
    tgBoundToast: '✅ TG 绑定成功！告警将发送到你的 Telegram',
    copyCmd: '复制命令', cmdCopied: '命令已复制',
    verifyBotHint: '发送一条测试消息到管理员配置的 Bot，验证 Bot 是否正常工作',
    kaLockBusy: '保活扫描正在后台执行，请稍后再试', kaRunError: '保活执行异常：{msg}', keepaliveTitle: '保活保护（防休眠）',
    keepaliveDesc: '连续 N 天无消耗的账户自动建主页赞广告防 FB 封号。保活广告永不被止损/哨兵停。',
    kaOnLabel: '已开启（本团队所有账户自动纳入）', kaOffLabel: '关闭（仅逐个开启保活的账户生效）',
    kaMasterOn: '保活总开关：开（保活正常自动运行）', kaMasterOff: '保活总开关：关（彻底停保活，含逐户开启的账户）',
    kaBudget: '单条预算', kaTriggerDays: '触发天数', days: '天', kaAssetPrefix: '素材前缀', saving: '保存中…',
    // 哨兵倒计时（dead-man switch）
    scdTitle: '哨兵倒计时', scdDesc: '你长时间未登录时自动开启哨兵（你名下纳管账户的投放系列将被停止），防止无人盯盘时持续空耗。你打开任意页面即刷新倒计时。',
    scdOnLabel: '已开启（超时自动开哨兵）', scdOffLabel: '关闭（不自动开启）',
    scdHours: '无交互阈值', hours: '小时', scdOn: '哨兵倒计时已开启',
    scdNote: '到点前 25% 时间会先发预警通知；自动开启不会自动解除，需到规则引擎页手动关闭哨兵恢复投放。',
  },
  teams: {
    title: '团队管理',
    desc: '平台所有团队。建团队时自动创建 3 个系统角色，可指定首任管理员。归档后团队隐藏但数据保留。',
    createTeam: '建团队', noTeams: '暂无团队，点「建团队」创建',
    teamName: '团队名', members: '成员', adAccounts: '广告账户', createdAt: '创建时间',
    manage: '管理', summary: '共 {n} 个团队 · {m} 个启用 · {d} 个域名', manageTitle: '团队管理 · {name}', rename: '重命名', suspend: '停用', activate: '激活', archive: '归档', restore: '恢复',
    domains: '域名', domainTitle: '域名管理 · {name}', domainAssigned: '已分配域名', domainNone: '暂无域名（从下方平台池勾选分配）',
    domainPool: '平台域名池（全部域名）', domainPoolEmpty: '平台无可用域名', domainAssignedTo: '已分给', domainFree: '未分配',
    domainSearch: '搜索域名', zoneActive: '已解析', zonePending: '解析中', domainOccupied: '已分配给其他团队',
    domainRevoke: '收回',
    hardDeleteTitle: '永久删除团队', hardDeleteBtn: '永久删除', hardDeleteConfirm: '将永久删除团队「{name}」及其全部数据（账户/模板/落地页/告警/日志，不可恢复）。确定继续？', hardDeleted: '团队已永久删除',
    createDesc: '建团队同时创建 3 个系统角色（管理员/运营/财务）。可选指定首任管理员（自动建用户并加入）。',
    teamNamePlaceholder: '如：客户A 投放团队',
    ownerEmail: '管理员邮箱', ownerEmailPlaceholder: '选填，留空 = 先建空团队',
    ownerPassword: '管理员密码', ownerPasswordPlaceholder: '选填，留空 = 系统随机生成',
    creating: '创建中…',
    memberManageTitle: '成员管理 · {name}', currentMembers: '当前成员（{n}）',
    you: '你', noMembers: '暂无成员', addNewMember: '添加新成员',
    email: '邮箱', memberEmailPlaceholder: '新成员邮箱（已存在则直接加入）',
    role: '角色', password: '密码', memberPasswordPlaceholder: '留空 = 系统随机生成',
    adding: '添加中…', addMember: '添加成员',
    loadFail: '加载失败', nameRequired: '填团队名', ownerEmailInvalid: '管理员邮箱格式不对',
    createdTeam: '团队「{name}」已创建',
    ownerExisting: '，已指定现有用户 {email} 为管理员',
    ownerNew: '，管理员 {email} 初始密码：{password}（请告知对方首次登录后修改）',
    emptyTeam: '（空团队，稍后可加成员）', createdTitle: '团队已创建', createFail: '创建失败',
    newName: '新团队名', renameTitle: '重命名 · {name}', cannotEmpty: '不能为空', renamed: '已重命名',
    confirmStatus: '确定将「{name}」设为{status}？', statusUpdated: '已更新',
    loadMembersFail: '加载成员失败', roleChanged: '{email} 角色改为{role}', changeRoleFail: '改角色失败',
    removeMemberConfirm: '移除成员「{email}」？（用户账号保留，只移出本团队）', memberRemoved: '已移除 {email}',
    emailRequired: '填邮箱', emailInvalid: '邮箱格式不对',
    addedExisting: '已把现有用户 {email} 加入',
    addedNew: '已创建 {email}，初始密码：{password}（请告知对方首次登录后修改）',
    addSuccess: '添加成功', addFail: '添加失败', noRolesYet: '该团队还没有角色（异常——建团会自动创建系统角色，请联系平台）',
  },
  adm: {
    ...admanager.zh,
    pageTitle: '广告管理器',
    loadAccountsFail: '加载账户失败',
    budgetDaily: '{v}/日', budgetLifetime: '{v} 总',
    budgetAdsetLevel: '广告组预算', budgetCampaignLevel: '系列预算',
    drillCampaign: '系列：{name}', drillAdset: '广告组：{name}',
    activated: '已开启', paused: '已暂停', active: '投放中',
    budgetGtZero: '预算必须大于 0', budgetUpdated: '预算已更新',
    delConfirm: '删除「{name}」？删除后不可恢复。', delCascadeCampaign: '⚠ 将连带删除其下全部广告组和广告（FB 不可逆）', delCascadeAdset: '⚠ 将连带删除其下全部广告（FB 不可逆）', filterIdleTip: '已开启但下面没有投放中的广告', deleted: '已删除',
    filterAbnormalTip: '被拒/审核中/有问题/被封等非正常态', accBannedTip: '账户已被 FB 禁用或存在禁用原因——状态来自缓存快照', accUnmanagedTip: '账户令牌已失效或已移除纳管——数据是最后快照，操作可能不生效', clearDrill: '退出下钻',
    selectRowsFirst: '先点选广告行',
    batchPauseConfirm: '批量暂停 {n} 条广告？', batchPauseTitle: '确认批量暂停',
    batchResult: '{ok}/{n} 成功', batchOpFail: '批量操作失败',
    diagFail: '诊断失败：{msg}',
    redirectSet: '跳转链接已设', redirectRestored: '已恢复默认跳转',
    resetRedirectsMsg: '清空所有广告跳转覆盖？所有广告将恢复落地页默认跳转。', redirectsCleared: '已清空 {n} 条',
    customRange: '自定义', allAccounts: '全部账户', searchNameId: '搜索广告名/ID',
    redirectLink: '跳转链接', selectedCount: '已选 {n} 条', selectAll: '全选/取消',
    batchBudget: '批量预算', batchBudgetTitle: '批量修改预算', batchBudgetType: '预算类型', batchBudgetDaily: '日预算', batchBudgetLifetime: '总预算(Lifetime)', batchBudgetAmount: '金额', batchBudgetPh: '输入新预算金额', batchBudgetNote: '金额按各账户本币计，将应用于全部所选系列/广告组。', batchBudgetMixedCur: '所选跨多个币种账户：同一数值按各自本币设置，请确认含义。', batchBudgetConfirm: '将把 {n} 项的{type}设为 {v}，确定？',batchActivate: '批量开启', batchPause: '批量暂停', clearSelection: '取消选择',
    tabCampaign: '系列', tabAdset: '广告组', tabAd: '广告',
    colSeries: '系列', colAdset: '广告组', colObjective: '目标', colOptGoal: '优化目标', colPixel: '转化像素',
    colBudget: '预算', colSpend: '消耗', colConversion: '转化', colReach: '覆盖', colFrequency: '频次',
    colSubcode: '子码', colVisits: '访问', colPass: '通过', colPassRate: '通过率',
    lpVisit: '落地访问', lpPass: '落地点击', lpTip: '访问=真实到达落地页的真人；落地点击=点了跳转按钮或自动跳转（去重）——FB点击含点赞评论等互动，两者口径不同',
    activate: '开启', editBudget: '改预算', redirectShort: '跳转',
    tabLead: '潜客',
    leadsCount: '共 {n} 条潜客', leadsSync: '从 FB 同步', leadsSubscribe: '订阅主页 webhook',
    leadsHint: '主页实时推送 + 手动同步补全答案',
    leadsSynced: '已同步 {n} 条', leadsSubscribed: '已订阅 {ok}/{n} 个主页', leadsErr: '{msg}',
    leadsUnsubscribe: '退订 webhook', leadsUnsubConfirm: '退订后所有主页的潜客推送将停止（潜客全部信息），需要时须重新订阅。确定退订？',
    leadsUnsubscribed: '已退订 {ok}/{n} 个主页', bgRefreshing: '后台刷新中…完成自动更新',
    refetchDone: '广告列表已更新；点击/消耗每 5 分钟自动同步',
    pagesPanelBtn: '主页与订阅', pagesPanelTitle: '主页受控清单', pagesPanelHint: '权限由 Facebook 侧分配（平台无法提升）：「可管理」=投放+潜客推送；「仅广告」=只可投放；「只读」=都不可。已订阅=潜客实时推送生效中',
    ppColPage: '主页', ppColPerm: '权限', ppColSub: '订阅', ppManage: '可管理', ppAdvertise: '仅广告', ppAdvertiseTip: '可投放广告，但订阅 webhook 需「管理主页」权限（BM/页设置分配）',
    ppView: '只读', ppViewTip: '该令牌在此页只有查看权限——投放与订阅都不可用', ppNoManage: '无「管理主页」权限，不可订阅',
    ppSubscribed: '已订阅', ppEmpty: '暂无主页（先在令牌页授权带主页的账号）', ppSubscribeSelected: '订阅选中（{n}）',
    purgeStaleBtn: '清理旧主页数据', purgeStaleConfirm: '将删除「不属于当前任何令牌主页」的历史潜客，并归档其表单模板（此后旧主页事件也不再入库）。该操作不可撤销，确定清理？',
    purgeStaleDone: '已清理：潜客 {leads} 条、表单模板 {tpls} 个',
    leadsEmpty: '暂无潜客（部署 Instant Form 后点同步，或主页 webhook 实时推送）',
    lcolTime: '提交时间', lcolName: '姓名', lcolEmail: '邮箱', lcolPhone: '电话', lcolSource: '来源', lcolDetail: '其他字段',
    lfCity: '城市', lfState: '省/州', lfZip: '邮编', lfCountry: '国家', lfGender: '性别', lfDob: '生日',
    lfMarital: '婚姻', lfCompany: '公司', lfJob: '职位', lfAddress: '地址', lfEmps: '员工数',
    leadStatus: { new: '新潜客', contacted: '已联系', won: '已成交', lost: '已流失' },
    lcolStatus: '跟进状态', lcolNote: '备注',
    leadStatusUpdated: '跟进状态已更新', leadNoteUpdated: '备注已保存',
    leadNoteTitle: '跟进备注 · {name}', leadNotePrompt: '记录跟进情况（留空保存 = 清除备注）',
    leadNoteTooLong: '备注过长（≤2000 字符）',
    redirectMarkTitle: '已设跳转：{url}（点击修改）',
    slugTitle: '/a/{slug} · 该广告通过 {pass}（点击查看落地页日志）',
    slugEmpty: '未铺', slugEmptyTitle: '该广告暂无落地流量（有访客后自动绑定子码）',
    lvTitle: '落地访问量', lpTitle: '通过量 = 按钮点击 + 跳转（按 IP 去重）',
    lprTitle: '通过 {pass} / 访问 {visits}', noVisits: '无访问', viewLandingLogs: '查看落地页日志',
    adDiagnose: '广告诊断', reuseThisPost: '复用此帖铺放', editBudgetTitle: '改预算 · {name}',
    lifetimeBudgetLabel: '总预算（本币）', dailyBudgetLabel: '日预算（本币）',
    redirectDialogTitle: '跳转链接 · {name}', redirectFormLabel: '该广告的专属跳转链接',
    redirectInputPh: 'https://...（留空=用落地页默认）',
    redirectHint: '设了之后，这条广告的访客都跳到这个链接；其他广告不受影响。留空保存 = 恢复落地页默认。',
    restoreDefault: '恢复默认', redirectMgmtTitle: '广告跳转链接管理',
    redirectMgmtCount: '共 {n} 条已设跳转', restoreAllDefault: '全部恢复默认',
    redirectMgmtEmpty: '暂无广告设了专属跳转（都走落地页默认）',
    diagBasicInfo: '基础信息', diagAccount: '账户', diagAdId: '广告ID', unbound: '未绑',
    diagFbStatus: 'FB状态', diagTodayData: '今日数据（{tz}）',
    diagImpressions: '曝光', diagClicks: '点击', diagFbConv: 'FB转化',
    diagLandingClicks: '落地点击', diagLandingVisits: '落地访问', diagEffectiveConv: '有效转化',
    dedupIp: '去重IP', diagRuleEval: '规则评估', colLandingShort: '落地', effectiveShort: '有效',
    diagNoRules: '暂无启用规则', diagCooldown: '冷却状态',
    diagCooldownMsg: '🔒 规则「{rule}」在 {ago} 分钟前暂停了此广告，冷却中（剩余 {left} 分钟内不重复执行）',
    diagWhitelisted: '今日已加白（巡检跳过此广告）', diagRecentActions: '最近操作',
    objSales: '销量', objTraffic: '流量', objEngagement: '互动', objAwareness: '品牌认知',
    objLead: '潜客', objMessages: '消息', objPageLikes: '主页赞', objVideoViews: '视频观看', objReach: '覆盖',
    optConversion: '转化', optLinkClicks: '链接点击', optLandingViews: '落地页浏览',
    optImpressions: '展示', optAppInstalls: '应用安装', optLeadGen: '潜在客户',
    optMsgConv: '消息对话', optValue: '价值',
    ruleBleedAbs: '空耗止损', ruleCpaExceed: 'CPA超标', ruleConsecutiveBad: '连续恶化', ruleCpmHigh: 'CPM过高', ruleCpcHigh: 'CPC过高', ruleClickFraud: '刷量嫌疑', ruleFastScale: '激进扩量',
    ruleClickNoConv: '点击无转化', ruleReachNoConv: '覆盖无转化', ruleLowCtrNoConv: '低CTR无转化',
    ruleBudgetBurnFast: '瞬烧制止', csFb: '仅Facebook', csLanding: '仅落地页', csEither: '综合（取大）',
    mixedCurrencyTip: '所选账户含多种币种，消耗/CPA 已折算 USD',
    dataAsOf: '数据截至 {t}', dataAsOfAgo: '（{v}）', dataAsOfTip: '点击/消耗数据由巡检每 5 分钟自动更新', cacheStaleTip: '数据已超过 1 小时未更新，建议刷新重拉',
    cacheAge: '数据 {n} 分钟前', cacheAgeLt1: '数据 <1 分钟', cacheAgeNone: '数据 —',
    cacheAgeSingle: '数据 {v}', cacheAdsStaleTip: '广告层超过 1 小时未更新，建议刷新重拉',
    cacheAgeShort: '{n} 分钟前', cacheAgeLt1Short: '<1 分钟',
    cacheAgeTip: '广告状态约每 5 分钟自动更新；系列/组结构约每 15 分钟。点「实时核验」立即获取平台最新状态',
    emptyAdsHint: '暂无数据——试试放宽日期范围 / 切换账户筛选；新广告可到「投放模板」一键部署',
    tokenDeadBar: '{n} 个账户已无可用令牌，其状态为最后快照——请到「令牌」页重新授权',
    tokenDeadTip: '数据连接失效后停止更新，列表为最后状态；重新授权后自动恢复实时',
    snapTag: '快照', snapTagTip: '该账户数据连接已失效，显示为最后状态（非实时）；重新授权后恢复', accUnmanaged: '已移除纳管', accBanned: '已禁', accUnmanagedTip: '此账户无可用令牌（已移除纳管或令牌失效），无法暂停/监控；数据为最后快照，请重新绑定令牌', accBannedTip: '此账户已被 Facebook 禁用，所有广告已停止', accUnmanagedBanner: '此账户无可用令牌（已移除纳管或令牌失效），无法暂停/监控；数据为最后快照，请重新绑定令牌', accBannedBanner: '此账户已被 Facebook 禁用——所有广告已停止投放', convDual: 'FB成效 {fb} / 综合转化 {total}',
    belongsToCampaign: '所属系列：{name}（点击行名查看该系列下的广告组）',
    refreshTip: '重新获取全部数据（后台 1-2 分钟完成）。只查开关状态用「⚡ 实时核验」更快', refreshCacheTip: '重新读取当前数据', refetch: '重新获取',
    refreshCacheShort: '读缓存刷新', srBtn: '复制消耗账户', srBtnTip: '按当前筛选生成行级消耗数据（含已移除账户的历史消耗）', srLoading: '拉取中…',
    srTitle: '消耗账户报告（{range}）', srMeta: '实时 {live} · 库内 {db}',
    srBasis: '按各账户本地日（与看板一致）', srBasisTip: '按各账户所在时区统计（与数据看板一致）',
    srOnlySpend: '仅看窗口内有消耗',
    srDate: '日期', srOwner: '归属人', srAccName: '账户名', srAccId: '账户ID', srSpend: '消耗金额(USD)', srSource: '来源', srStatus: '状态',
    srLive: '实时', srDb: '库内', srManaged: '在管', srRemoved: '已移除',
    srLastRec: '最后记录', srLastRecTip: '已移除账户停投前最后一个有消耗的库内日（仅参考，不计入窗口消耗）',
    srCopy: '复制', srCopied: '已复制 {n} 行（可直接粘贴到表格）', srEmpty: '当前筛选窗口内无有消耗账户',
    liveVerify: '实时核验', liveVerifying: '核验中…', liveVerifyTip: '只查开/关状态（秒级），不拉名称/创意/消耗；完整更新请用页头「重新获取」',
    liveVerifiedAt: '已实时核验 {time}', liveVerifyOk: '已实时核验 {n} 条广告状态', liveVerifyFail: '实时核验失败',
    liveVerifyPickAccount: '请先在上方账户筛选中选择账户，再实时核验', liveVerifyTooOften: '这些账户 10 秒内已核验过，请稍候再试',
    fakePauseWarn: '操作已提交，但回读核验发现实际状态未生效（可能假停）——建议点「实时核验」复查',
    batchActivateConfirm: '即将恢复 {n} 条广告投放', batchActivateTitle: '确认批量开启',
    budgetBigJumpTitle: '确认预算大幅上调', budgetBigJumpConfirm: '预算变动较大：{change}，确认应用？',
    reviewFlagTitle: '拒审原因', reviewFlagHint: '点击查看拒审原因', thumbTitle: '创意缩略图',
    redirectRemoveConfirm: '移除该广告的专属跳转链接？恢复为默认目标。',
    loadFailed: '数据加载失败',
    thumbNoneShort: '无预览', thumbArchivedShort: '已归档', thumbNone: '平台未返回此广告的预览图', thumbArchived: '已归档广告：素材已失效，平台不再提供预览图',
    rename: '重命名', renameTitle: '重命名 · {name}', renamePrompt: '新名称',
    renameEmpty: '名称不能为空', renameTooLong: '名称不能超过 200 字符', renamed: '已重命名',
    filterAbnormal: '异常', scopeAccounts: '{n} 账户', totalRow: '合计（{n} 条）',
    shownOf: '已显示 {s} / {n} 条，继续滚动加载更多',
  },
  kpi: {
    loadFail: '加载失败',
    resetConfirm: '恢复全部映射为系统默认值？当前自定义配置将被覆盖。',
    resetDone: '已恢复默认', resetDefault: '恢复默认',
    tabMatrix: '映射矩阵', tabObjective: '未知目标备选', tabFallback: '备选优先级',
    ttObjectiveHint: 'TikTok 按广告目标对应取数；转化数以平台报表数据为准。',
    ttNoMatrix: 'TikTok 目标为单层结构，无需此映射（见「未知目标备选」TikTok 分组）。',
    ttNoFallback: 'TikTok 转化数直接取报表数据，无需备选。',
    ttNoPoor: 'TikTok 报表转化已按目标聚合，无需排除指标。',
    tabPoor: '排除的指标', tabLabels: '指标名称',
    fallbackHint: '自动识别转化时按此优先级取第一个非零值',
    poorHint: '以下指标不计为转化（浏览/点击/互动类），自动识别时跳过',
    labelsHint: '转化指标 → 显示名称',
    fieldPurchase: '购买', fieldLead: '潜客', fieldMessaging: '私信会话',
    fieldAppInstall: '应用安装', fieldRegistration: '注册完成', fieldPageLike: '主页赞',
    fieldPostEngagement: '帖子互动', fieldLinkClick: '链接点击', fieldLandingView: '落地页浏览',
    fieldVideoView: '视频观看', fieldThruplay: 'ThruPlay', fieldAddToCart: '加入购物车',
    fieldInitiateCheckout: '发起结账', fieldTtConversion: '转化（TT）',
    matrixEmpty: '映射矩阵为空——转化识别将使用系统默认值（新增目标后自动补充）。',
  },
  dashboard: dashboard.zh,
  launch: launch.zh,
  formtpl: formtpl.zh,
  assets: assets.zh,
  lm: {
    batchImport: '批量导入', addOne: '添加一条', count: '共 {n} 条',
    itemUrl: '链接', itemDomain: '域名',
    edit: '编辑',
    tipUrl: '粘贴链接，每行一条（# 开头的行忽略）。无 http(s) 前缀自动补 https://，重复自动跳过。',
    tipDomain: '粘贴域名，每行一条（如 lp.example.com）。自动去前缀/路径、转小写，重复自动跳过。',
    taPh: 'https://example.com/offer1（一行一条，可多行粘贴）',
    recognize: '自动识别', found: '识别 {n} 条可导入', dupSkipped: '重复跳过 {n} 条',
    invalidN: '无法识别 {n} 条：', badUrl: '不是有效链接', badDomain: '不是有效域名',
    importBtn: '导入 {n} 条', imported: '已导入 {n} 条',
  },
  bm: {
    total: '共 {n} 个 BM', colBm: 'BM', colVia: '归属令牌', colRole: '角色',
    tabMembers: '成员', tabAssets: '资产', colPage: '旗下主页',
    accCount: '广告账户 {n}', pgCount: '主页 {n}', noMembers: '暂无成员数据（或令牌无权限读取）',
    needEmail: '请输入邮箱', invite: '邀请', emailPh: '成员邮箱（Facebook 账号邮箱）', adminConfirm: 'ADMIN 可以管理该 BM 的所有成员和资产（包括增删其他管理员），权限较大。确定授予？', removeConfirm: '移除成员「{n}」？其 BM 权限即时失效。', writeBlocked: 'BM 管理操作暂不可用：需 Facebook App 通过 business_management 权限审核并切换为 Live Mode，审核通过后自动恢复', invited: '邀请已发送', noAssets: '暂无资产数据（或令牌无权限读取）', none: '暂无 BM（令牌未关联 Business Manager）', roleFull: '完全控制', roleEmployee: '普通成员',
  },
  pg: {
    unpublished: '未发布',
    searchPh: '搜索主页名 / ID / 归属令牌', total: '共 {n} 个主页',
    colPage: '主页', colVia: '归属令牌', colCat: '类型', colFans: '粉丝', colAds: '在投广告', colTpl: '被模板引用',
    tplN: '{n} 个', copyId: '点击复制 ID', noMatch: '无匹配主页', none: '暂无主页（令牌未配置或无可管主页）', renameBtn: '重命名', categoryBtn: '改类型', categoryPh: '搜索或输入主页类别', pageRenamePrompt: '新的主页名称（将真实修改 Facebook 主页名）', pageRenameLimit: '名称需 1-100 字符', pageRenamed: '主页已重命名', pageCategoryPrompt: '新的主页类别（如 Internet Marketing Service，将真实修改 FB 主页类型；需主页管理权限）', pageCategoryLimit: '1-120 字符', pageCategorySaved: '主页类别已更新',
  },
  domains: {
    tabBuy: '买域名', tabMine: '我的域名', tabOrders: '订单',
    srcPurchased: '代购', srcOwn: '自有', zoneActive: 'DNS 已生效', zonePending: 'DNS 生效中',
    usedBy: '{n} 个落地页在用', noUse: '此域暂无落地页在用', noMine: '还没有团队域名——买一个或绑定自有域名', goBuy: '去买域名',
    approve: '确认收款', approveOk: '{d} 已确认收款，自动注册并接入中（完成入「我的域名」）', approveParked: '{reg} 尚未配置凭据，订单已标记「已收款」；配置注册商后再点「确认收款」继续注册',
    takenNow: '域名 {d} 刚被占用或不可注册，已从列表移除——换一个试试', payPoolN: '点「去支付」查看本单收款地址',
    scanPay: '扫码支付（TokenPocket/TronLink）', netOnly: '支持 USDT-TRC20（TRON 网络）——最常用的 USDT 通道', netWarn: '请勿使用 ERC20/BEP20 或选错提币网络——转错网络的资产无法找回', payDomain: '订单域名', payAmtLabel: '应付金额', amtCopied: '金额已复制', waitingPay: '等待到账…', payAutoDetect: '转账后约 1-2 分钟自动确认并交付，无需人工。', payBtn: '去支付', payTo: '请向以下地址转 USDT：', payCopied: '收款地址已复制', stDetected: '已到账·注册中', payAmt: '应付 ${v}', payAmtTip: '请按此金额精确转账，到账后自动确认', orderedPay: '已下单，应付 ${v}（USDT，订单页有收款地址）', listNote: '价格含全部费用（价低在前）· 实际可注册性与实时价以下单核验为准', costBrkTip: '成本拆分：域名成本 + 平台服务费（仅超管可见）',
  },
  wallet: {
    tab: '钱包', balanceLabel: '团队余额', balanceTip: '团队余额=平台钱包（买单/续费从这里扣）；各广告账户的可用额度看「广告管理」列表', teamNote: '团队共用（买单/续费从这扣）',
    topupBtn: '充值', topupTitle: '钱包充值', amtLabel: '充值金额', amtPh: '如 100', amtMin: '充值金额至少 1 美元',
    topupHint: 'USDT 转账后约 1-2 分钟自动到账，无需人工。',
    topupGo: '生成收款信息', topupCancelled: '充值单已取消',
    allTeams: '全平台团队余额', total: '合计', noAccounts: '还没有团队开通钱包（充值/消费后自动建立）',
    adjustBtn: '调整', adjustTitle: '钱包人工调整', adjAmtLabel: '调整金额', adjAmtPh: '如 50 或 -20',
    adjNoteLabel: '原因（必填）', adjNotePh: '如：订单 #12 退款 / 纠错 / 赠送',
    adjHint: '正数=加款、负数=扣款；每笔计入流水，操作会记入日志。',
    adjAmtRequired: '填调整金额（±）', adjNoteRequired: '填调整原因', adjDone: '已调整，余额 ${v}',
    txnsTitle: '流水（最近 50 笔）', noTxns: '暂无流水',
    txDeposit: '充值', txCharge: '消费', txRefund: '退款', txAdjust: '调整',
    balAfter: '余额', refTopup: '充值 #{id}', refOrder: '订单 #{id}', refOrderRefund: '订单 #{id} 退回',
  },
  dom: {
    expTitle: '到期日 {d}', expDays: '剩 {n} 天', expToday: '今天到期', expExpired: '已过期',
    autoRenew: '自动续费', autoTip: '开启后：到期前如余额充足将自动续费（1 年）并通知；余额不足会提前提醒，请及时充值',
    autoOn: '自动续费已开启', autoOff: '自动续费已关闭',
    renewBtn: '续费', renewTitle: '续费 · {d}', curExpires: '当前到期', renewYears: '续费年限',
    yearsN: '{n} 年', renewPrice: '续费价', perYear: '${v}/年',
    payWallet: '余额充足：点确认即时扣款续费。', payUsdt: '余额不足：将生成 USDT 直付单，到账后自动续费（也可先去钱包充值）。',
    renewGo: '确认续费', renewDone: '续费成功，新到期日 {d}', renewOrderCreated: '续费单已创建，应付 ${v}（订单页付款）',
    regExternal: '自有域名', regNone: '自有域名', regPlatform: '平台代购', lastRenewed: '最近续费 {d}',
  },
  landing: landing.zh,
  guard: guard.zh,
  lplogs: lplogs.zh,
}
